import { CustomerMeeting } from "../store/CustomerMeeting";
import { CustomerMeetingDto } from "./api/CustomerMeetingDto";

export class CustomerMeetingFromResponse {
    constructor(private customerMeetingFromResponse: CustomerMeetingDto) {}

    customerMeeting(): CustomerMeeting {
        return {
            meetingId: this.customerMeetingFromResponse.meetingId,
            organizerId: this.customerMeetingFromResponse.organizerId,
            subject: this.customerMeetingFromResponse.subject,
            customerFullName: this.customerMeetingFromResponse.customerFullName,
            joinUrl: this.customerMeetingFromResponse.joinUrl,
            urlHash: this.customerMeetingFromResponse.urlHash,
            startAt: new Date(this.customerMeetingFromResponse.startAt),
            endAt: new Date(this.customerMeetingFromResponse.endAt),
            status: this.customerMeetingFromResponse.status,
            businessLine: this.customerMeetingFromResponse.businessLine,
            isCancelled: this.customerMeetingFromResponse.isCancelled,
        };
    }
}
